"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSTT001_List = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const DSST001_List_Child_1 = require("../../DSS/DSST001/DSST001_List_Child");
const RegistButton_1 = require("../RegistButton");
const DSTT001_List_Child_1 = require("./component/DSTT001_List_Child");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const react_redux_1 = require("react-redux");
const action_1 = require("../../menu/action");
const classes_1 = require("../../base/classes");
const DSTT001_ListStyled = styled_components_1.default.div `
	width: 100%;
	display: flex;
	height: min-content;
	flex: 1;
	// background: var(--color-silver, #f3f4f8);
	.reservation-table {
		width: 100%;
		height: ${props => props.$isMobile ? 'min-content' : '100%'};
		min-height: 100%;
		${props => props.$isTeacher && props.$isMobile && `padding: 20px`};
	}

	${props => !props.$isTeacher &&
    `display: flex; 
		flex-direction: column; 
		gap: 40px;  
		.review_class_list {
			min-height: 342px;
			}`}
			
	${props => props.$isMobile &&
    `overflow: auto;
		background: var(--color-silver, #f3f4f8);
		gap: ${props.$isTeacher ? '0px' : '12px'};
	`}

	
`;
exports.DSTT001_List = react_1.default.memo(({ isClosed = false, isPrevious = false, isTeacher = false, }) => {
    const { isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const hiddenMenus = (0, react_redux_1.useSelector)((state) => (0, classes_1.getHiddenMenus)(state));
    const noReplay = hiddenMenus?.includes('replay') || hiddenMenus?.includes('replay-student');
    const noReservation = hiddenMenus?.includes('reservation');
    const noPreviousConference = hiddenMenus?.includes('previous-conference');
    const hideTable = isTeacher ? noReservation && noPreviousConference : noReservation;
    const handlerButtonClick = () => {
        dispatch((0, action_1.updateMenu)(undefined, {
            menu: isPrevious ? 'previous-conference' : 'reservation',
            detail: 'regist',
        }));
    };
    return (react_1.default.createElement(DSTT001_ListStyled, { "$isTeacher": isTeacher, "$isMobile": isMobile, "$isTablet": isTablet },
        !hideTable && (react_1.default.createElement(DSTT001_List_Child_1.ReservationTable, { isClosed: isClosed, isPrevious: isPrevious })),
        isTeacher ? (isPrevious ? null : (react_1.default.createElement(RegistButton_1.RegistButton, { handlerButtonClick: handlerButtonClick }))) : (!noReplay && (react_1.default.createElement(DSST001_List_Child_1.ReviewClassList, null)))));
});
